module.exports = __webpack_public_path__ + "img/agencyModel.13a62e7b.png";